module.exports = __webpack_public_path__ + "img/gantong.e6222c5d.png";